import React, { useEffect, useState } from 'react'
import UserSideBar from './UserSideBar'
import { UserPosts } from './UserPosts'
import { redirect } from 'react-router-dom'
import axios from 'axios'
import { JwtDecoder } from '../../Utils/JwtDecoder'
import base_url from '../../Utils/server'
import { toast } from 'react-toastify'

export function loader({req}){
  console.log(sessionStorage.getItem("jwtToken")==null)
  if(sessionStorage.getItem("jwtToken")==null){
    throw redirect("/?message=PleaseLogin")
  }
  return null;
}
export const UserProfile = () => {
  const [posts, setPosts] = useState([]);
  const [matchArray, setMatchArray] = useState(posts);
  const Token = sessionStorage.getItem("jwtToken");
  const decoded = JwtDecoder(Token);
  let url = `${base_url}/posts/user/${decoded.userName}`;
  useEffect(()=>{
    axios
      .get(`${base_url}/posts/user/${decoded.userName}`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        if(res.data.status=="success"){
          setPosts(res.data.data);
          setMatchArray(res.data.data);
        }
        else{
          toast.error(res.data.message)
        }
      })
      .catch((e)=>{
        toast.error("Network Error.")
      });
  },[])
  useEffect(()=>{},[posts]);
  return (
    <>
    <UserSideBar setPosts={setPosts}  /> \
    <UserPosts posts={posts} setPosts={setPosts}  matchArray={matchArray} setMatchArray={setMatchArray} url={url}/>
    </>
  )
}
